import { cx } from '../../utils/cx';
import { getInitial } from '../../utils/getInitials';

import Avatar, { type IAvatarProps } from './Avatar';

const styles = {
  sm: { root: 'gap-2', title: 'text-sm font-semibold', subtitle: 'text-xs' },
  md: { root: 'gap-2', title: 'text-sm font-semibold', subtitle: 'text-sm' },
  lg: { root: 'gap-3', title: 'text-md font-semibold', subtitle: 'text-md' },
  xl: { root: 'gap-4', title: 'text-lg font-semibold', subtitle: 'text-md' },
};

interface IAvatarLabelGroupProps extends IAvatarProps {
  size: 'sm' | 'md' | 'lg' | 'xl';
  title: string;
  subtitle: string;
}

const AvatarLabelGroup = ({ title, subtitle, className, ...props }: IAvatarLabelGroupProps) => {
  return (
    <div className={cx('group flex min-w-0 flex-1 items-center', styles[props.size].root, className)}>
      <Avatar {...props} initials={getInitial(title)} />
      <div className="min-w-0 flex-1 text-left">
        <span className={cx('text-primary block', styles[props.size].title)}>{title}</span>
        <span className={cx('text-tertiary block truncate', styles[props.size].subtitle)}>{subtitle}</span>
      </div>
    </div>
  );
};

export default AvatarLabelGroup;
